import { Component, input } from '@angular/core';

import type { Entry } from './utils';
import { wrapContent } from './utils';

/**
 * Component that wraps links in the content with anchor tags.
 * You may need it if you want to avoid using innerHTML, but need to display links anyway.
 */
@Component({
  selector: 'rt-link-wrapper',
  template: `
    @for (entry of wrappedContent(); track $index) {
      @if (entry.type === 'url' || entry.type === 'email') {
        <a [href]="entry.protocol + entry.value" target="_blank">
          {{ entry.keepProtocol ? entry.protocol + entry.value : entry.value }}
        </a>
      } @else {
        {{ entry.value }}
      }
    }
  `,
  styles: `
    a:before {
      content: ' ';
    }
    a:after {
      content: ' ';
    }
  `,
  standalone: true,
})
export class LinkWrapperComponent {
  public wrappedContent = input.required<Entry[], string>({
    alias: 'content',
    transform: (value: string) => wrapContent(value),
  });
}
